<es-document-download
  *ngFor="let document of otherLineItemDocs; let docIndex = index"
  [validationMessages]="validationMessages"
  [isCanUploadDocuments]="isCanUploadDocuments"
  [isCanRemoveDocuments]="isCanRemoveDocuments"
  [attachmentTypeName]="('LABELS.LINE' | translate) + (index !== undefined ? ' #' + (index + 1) : '')"
  [attachmentName]="lineItem.htsNumber | mask : HTS_MASK"
  [attachmentHint]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
  [id]="'upload-line-item-other-file-' + lineItem.id + '-' + index + '-' + docIndex"
  [document]="document"
  [upload]="upload"
  [remove]="remove"
  (stateUpdate)="onStateUpdate($event)"
></es-document-download>

<ng-template [ngIf]="isCanLoadOther">
  <document-add-other [createDocument]="createDocumentTemplate" [includesTypes]="includesTypes" [upload]="upload"></document-add-other>
</ng-template>
